import http from '@/utils/http'

const buyApi = {

  // 选择商品1 渲染
  choiceGoods(data: any) {
    return http.get<any>('/business/resource/purchase/setting/commodity/render', { data })
  },

  // 选择商品1 搜索
  searchGoods(data: any) {
    return http.get<any>('/business/resource/purchase/setting/commodity/fuzzyQuery', { data })
  },

  // 选择商品1 保存
  submitGoods(data: any) {
    return http.post<any>('/business/resource/purchase/setting/commodity/save', data)
  },


  // 选择档期2 渲染
  choiceTime(data: any) {
    return http.post<any>('/business/resource/purchase/setting/schedule/render', data)
  },

  // 选择档期2 保存
  submitTime(data: any) {
    return http.post<any>('/business/resource/purchase/setting/schedule/save', data)
  },

  // 选择渠道3 渲染
  choiceChannel(data: any) {
    return http.post<any>('/business/orderResource/findById', data)
  },

  // 选择门店3 添加购物车
  addCarts(data: any) {
    return http.post<any>('/business/orderResource/addShopCart', data)
  },

  // 选择了门店3 点击下单
  buy(data: any) {
    return http.post<any>('/business/orderResource/commitOrder', data)
  },

  // 库存 锁定接口
  locked(data: any) {
    return http.get<any>('/business/orderResource/find/locked', {data})
  },
  // 确认订单4 渲染
  confirmOrder(data: any) {
    return http.post<any>('/business/orderResource/findBusinessSureOrder', data)
  },

  // 提交订单4 
  submitOrder(data: any) {
    return http.post<any>('/business/orderResource/createOrder', data)
  },


  // 判断是否有支付密码  删
  havePassword(data: any) {
    return http.get<any>('/finance/inside/checkPayPasswordExist', { data })
  },

  // 完整订单页面类容
  getOrderMessage(data: any) {
    return http.get<any>('/business/resource/purchase/order/renderPage', { data })
  },

  // 完成订单支付5
  pay(data: any) {
    return http.post<any>('/business/resource/purchase/order/pay', data)
  },

  // 调取获取支付状态
  checkOrderType(data: any) {
    return http.get<any>('/business/resource/purchase/order/check', { data })
  },

  // 获取图片验证码
  generatorImgCode() {
    return http.get<any>('/account/login/generatorImgCode')
  }
}
export default buyApi